function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllWaistline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "251.25pt",
    height: "75pt",
    viewBox: "0 0 251.25 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,88.235294%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 214.914062 20.03125 C 208.742188 10.140625 197.167969 6.800781 187.589844 12.140625 C 182.242188 15.179688 175.769531 15.5 170.144531 13.003906 L 168.75 12.375 C 154.03125 5.832031 137.21875 5.875 122.535156 12.496094 L 112.875 16.808594 C 107.609375 19.183594 101.558594 19.082031 96.375 16.53125 L 90.21875 13.53125 C 75.5625 6.34375 58.238281 7.234375 44.390625 15.878906 C 34.714844 21.789062 31.371094 28.171875 32.121094 36.625 C 33.171875 48.40625 29.121094 60.023438 20.8125 67.21875 L 16.09375 71.324219 L 229.09375 71.324219 C 245.78125 33.261719 216.148438 40.035156 214.917969 20.03125 Z M 214.914062 20.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 237.359375 72.074219 L 231 72.074219 C 230.585938 72.074219 230.25 71.738281 230.25 71.324219 C 230.25 70.910156 230.585938 70.574219 231 70.574219 L 237.382812 70.574219 C 237.796875 70.574219 238.132812 70.910156 238.132812 71.324219 C 238.132812 71.738281 237.796875 72.074219 237.382812 72.074219 Z M 237.359375 72.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 224.023438 72.074219 L 210.699219 72.074219 C 210.285156 72.074219 209.949219 71.738281 209.949219 71.324219 C 209.949219 70.910156 210.285156 70.574219 210.699219 70.574219 L 224.023438 70.574219 C 224.4375 70.574219 224.773438 70.910156 224.773438 71.324219 C 224.773438 71.738281 224.4375 72.074219 224.023438 72.074219 Z M 224.023438 72.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 198.390625 72.074219 L 67.230469 72.074219 C 66.816406 72.074219 66.480469 71.738281 66.480469 71.324219 C 66.480469 70.910156 66.816406 70.574219 67.230469 70.574219 L 198.390625 70.574219 C 198.804688 70.574219 199.140625 70.910156 199.140625 71.324219 C 199.140625 71.738281 198.804688 72.074219 198.390625 72.074219 Z M 198.390625 72.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 53.738281 72.074219 L 41.738281 72.074219 C 41.324219 72.074219 40.988281 71.738281 40.988281 71.324219 C 40.988281 70.910156 41.324219 70.574219 41.738281 70.574219 L 53.738281 70.574219 C 54.152344 70.574219 54.488281 70.910156 54.488281 71.324219 C 54.488281 71.738281 54.152344 72.074219 53.738281 72.074219 Z M 53.738281 72.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.5 72.074219 L 13.890625 72.074219 C 13.476562 72.074219 13.140625 71.738281 13.140625 71.324219 C 13.140625 70.910156 13.476562 70.574219 13.890625 70.574219 L 28.5 70.574219 C 28.914062 70.574219 29.25 70.910156 29.25 71.324219 C 29.25 71.738281 28.914062 72.074219 28.5 72.074219 Z M 28.5 72.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 153 46.417969 C 152.65625 45.832031 152.25 45.242188 151.875 44.671875 C 149.839844 41.738281 148.554688 38.351562 148.125 34.808594 C 148.015625 33.945312 147.964844 33.074219 147.96875 32.203125 L 147.96875 30.75 C 147.964844 28.980469 148.175781 27.21875 148.597656 25.5 L 151.738281 17.632812 C 152.929688 14.742188 153.777344 11.71875 154.265625 8.632812 L 154.921875 4.5 L 96.328125 4.5 L 97.019531 8.648438 C 97.511719 11.734375 98.359375 14.753906 99.546875 17.648438 L 102.691406 25.5 C 103.109375 27.21875 103.324219 28.980469 103.320312 30.75 L 103.320312 32.183594 C 103.320312 32.582031 103.320312 32.933594 103.320312 33.339844 L 101.355469 41.25 C 100.820312 42.457031 100.167969 43.601562 99.40625 44.675781 C 96.796875 48.59375 94.753906 52.855469 93.328125 57.335938 C 91.722656 62.046875 90.199219 67.28125 90.199219 70.085938 L 161.042969 70.085938 C 161.042969 67.257812 159.542969 62.023438 157.914062 57.335938 L 157.921875 57.335938 C 156.695312 53.523438 155.042969 49.863281 153 46.417969 Z M 153 46.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.980392%,70.196078%,28.627451%)",
      fillOpacity: 1
    },
    d: "M 131.871094 39.660156 L 131.871094 60.660156 C 131.871094 63.039062 129.433594 66.179688 123.132812 65.296875 C 116.832031 64.410156 120.273438 51.585938 119.929688 48.257812 C 119.585938 44.925781 113.25 46.5 112.363281 50.144531 C 111.476562 53.789062 107.796875 60.546875 106.972656 52.988281 C 106.148438 45.429688 99.40625 44.671875 99.40625 44.671875 C 100.167969 43.597656 100.820312 42.449219 101.355469 41.242188 L 103.289062 33.359375 L 125.625 34.679688 Z M 131.871094 39.660156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.980392%,70.196078%,28.627451%)",
      fillOpacity: 1
    },
    d: "M 153 46.417969 C 150.335938 46.179688 145.941406 45.976562 143.023438 46.65625 C 138.597656 47.714844 135.15625 43.714844 135.15625 39.660156 C 135.15625 37.5 141.832031 35.863281 148.117188 34.808594 C 148.546875 38.351562 149.835938 41.738281 151.867188 44.671875 C 152.25 45.238281 152.625 45.832031 153 46.417969 Z M 153 46.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 161.054688 70.851562 C 160.640625 70.851562 160.304688 70.515625 160.304688 70.101562 C 160.304688 67.851562 159.238281 63.515625 157.222656 57.5625 C 155.820312 53.148438 153.800781 48.953125 151.222656 45.105469 C 148.59375 41.332031 147.183594 36.847656 147.179688 32.25 L 147.179688 30.75 C 147.179688 28.914062 147.398438 27.082031 147.832031 25.296875 L 147.832031 25.199219 L 150.980469 17.324219 L 150.984375 17.324219 C 152.136719 14.488281 152.964844 11.535156 153.457031 8.511719 L 154.15625 4.363281 C 154.222656 3.949219 154.613281 3.671875 155.027344 3.738281 C 155.441406 3.808594 155.722656 4.199219 155.65625 4.613281 L 154.964844 8.753906 C 154.453125 11.882812 153.59375 14.949219 152.398438 17.886719 L 149.25 25.71875 C 148.851562 27.371094 148.652344 29.066406 148.648438 30.765625 L 148.648438 32.25 C 148.644531 36.539062 149.953125 40.726562 152.398438 44.25 C 155.050781 48.214844 157.132812 52.535156 158.578125 57.082031 C 160.679688 63.277344 161.742188 67.65625 161.742188 70.101562 L 161.746094 70.101562 C 161.746094 70.496094 161.445312 70.820312 161.054688 70.851562 Z M 161.054688 70.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 90.195312 70.851562 C 89.78125 70.851562 89.445312 70.515625 89.445312 70.101562 C 89.445312 67.65625 90.511719 63.277344 92.609375 57.082031 C 94.058594 52.535156 96.140625 48.214844 98.796875 44.25 C 99.519531 43.234375 100.136719 42.144531 100.636719 41.003906 L 102.550781 33.257812 C 102.550781 32.914062 102.550781 32.574219 102.550781 32.222656 L 102.546875 30.75 C 102.546875 29.050781 102.34375 27.355469 101.949219 25.703125 L 98.820312 17.878906 C 97.625 14.941406 96.765625 11.882812 96.253906 8.753906 L 95.5625 4.613281 L 95.566406 4.613281 C 95.496094 4.199219 95.777344 3.808594 96.191406 3.738281 C 96.605469 3.671875 96.996094 3.949219 97.066406 4.363281 L 97.765625 8.503906 L 97.761719 8.503906 C 98.25 11.527344 99.082031 14.484375 100.238281 17.316406 L 103.386719 25.199219 L 103.386719 25.296875 C 103.820312 27.082031 104.039062 28.914062 104.039062 30.75 L 104.039062 32.25 C 104.039062 32.664062 104.039062 33.046875 104.039062 33.449219 C 104.046875 33.496094 104.046875 33.539062 104.039062 33.585938 L 102.074219 41.414062 C 102.078125 41.453125 102.078125 41.496094 102.074219 41.535156 C 101.527344 42.792969 100.851562 43.992188 100.058594 45.113281 C 97.476562 48.960938 95.457031 53.152344 94.058594 57.570312 C 92.042969 63.519531 90.976562 67.851562 90.976562 70.101562 C 90.976562 70.308594 90.890625 70.503906 90.746094 70.644531 C 90.597656 70.785156 90.398438 70.859375 90.195312 70.851562 Z M 90.195312 70.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,27.843137%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 129.621094 61.394531 L 121.746094 61.394531 L 121.746094 41.152344 L 129.621094 40.402344 Z M 129.621094 61.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 121.746094 49.027344 L 129.621094 49.027344 L 129.621094 62.902344 L 121.746094 62.902344 Z M 121.746094 49.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 129.621094 40.402344 L 129.621094 62.902344 L 121.746094 62.902344 L 121.746094 41.152344 L 129.621094 40.402344 M 129.621094 38.902344 L 129.480469 38.902344 L 121.605469 39.652344 C 120.832031 39.726562 120.242188 40.375 120.246094 41.152344 L 120.246094 62.902344 C 120.246094 63.300781 120.40625 63.683594 120.6875 63.964844 C 120.96875 64.246094 121.351562 64.402344 121.746094 64.402344 L 129.621094 64.402344 C 130.019531 64.402344 130.402344 64.246094 130.683594 63.964844 C 130.964844 63.683594 131.121094 63.300781 131.121094 62.902344 L 131.121094 40.402344 C 131.121094 39.980469 130.941406 39.574219 130.628906 39.292969 C 130.351562 39.042969 129.996094 38.902344 129.621094 38.902344 Z M 129.621094 38.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 129.621094 39.652344 L 98.128906 39.652344 L 98.128906 31.777344 L 124.371094 31.777344 Z M 129.621094 39.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 137.378906 31.777344 L 153.121094 31.777344 L 153.121094 39.652344 L 137.378906 39.652344 Z M 137.378906 31.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,38.039216%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 126.390625 35.714844 L 98.128906 35.714844 L 98.128906 31.777344 L 124.371094 31.777344 Z M 126.390625 35.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,38.039216%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 137.378906 31.777344 L 153.121094 31.777344 L 153.121094 35.804688 L 137.378906 35.804688 Z M 137.378906 31.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 124.371094 31.777344 L 129.621094 39.652344 L 98.121094 39.652344 L 98.121094 31.777344 L 124.371094 31.777344 M 124.371094 30.277344 L 98.121094 30.277344 C 97.292969 30.277344 96.621094 30.949219 96.621094 31.777344 L 96.621094 39.652344 C 96.621094 40.050781 96.78125 40.433594 97.0625 40.714844 C 97.34375 40.996094 97.726562 41.152344 98.121094 41.152344 L 129.621094 41.152344 C 130.175781 41.152344 130.683594 40.847656 130.941406 40.359375 C 131.203125 39.871094 131.175781 39.28125 130.867188 38.820312 L 125.617188 30.945312 C 125.339844 30.527344 124.871094 30.277344 124.371094 30.277344 Z M 124.371094 30.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 153.121094 31.777344 L 153.121094 39.652344 L 137.371094 39.652344 L 137.371094 31.777344 L 153.121094 31.777344 M 153.121094 30.277344 L 137.371094 30.277344 C 136.542969 30.277344 135.871094 30.949219 135.871094 31.777344 L 135.871094 39.652344 C 135.871094 40.050781 136.027344 40.433594 136.308594 40.714844 C 136.589844 40.996094 136.972656 41.152344 137.371094 41.152344 L 153.121094 41.152344 C 153.519531 41.152344 153.898438 40.996094 154.179688 40.714844 C 154.460938 40.433594 154.621094 40.050781 154.621094 39.652344 L 154.621094 31.777344 C 154.621094 31.378906 154.460938 31 154.179688 30.71875 C 153.898438 30.433594 153.519531 30.277344 153.121094 30.277344 Z M 153.121094 30.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 145.246094 40.027344 C 145.039062 40.027344 144.871094 39.859375 144.871094 39.652344 L 144.871094 37.027344 C 144.871094 36.820312 145.039062 36.652344 145.246094 36.652344 C 145.34375 36.652344 145.441406 36.691406 145.511719 36.761719 C 145.582031 36.832031 145.621094 36.929688 145.621094 37.027344 L 145.621094 39.652344 C 145.621094 39.753906 145.582031 39.847656 145.511719 39.917969 C 145.441406 39.988281 145.34375 40.027344 145.246094 40.027344 Z M 145.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 151.246094 40.027344 C 151.039062 40.027344 150.871094 39.859375 150.871094 39.652344 L 150.871094 37.027344 C 150.871094 36.820312 151.039062 36.652344 151.246094 36.652344 C 151.34375 36.652344 151.441406 36.691406 151.511719 36.761719 C 151.582031 36.832031 151.621094 36.929688 151.621094 37.027344 L 151.621094 39.652344 C 151.621094 39.753906 151.582031 39.847656 151.511719 39.917969 C 151.441406 39.988281 151.34375 40.027344 151.246094 40.027344 Z M 151.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.470588%,56.470588%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 137.378906 31.777344 L 139.5 31.777344 L 139.5 39.652344 L 137.378906 39.652344 Z M 137.378906 31.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.686275%,75.686275%,75.686275%)",
      fillOpacity: 1
    },
    d: "M 137.378906 31.777344 L 139.5 31.777344 L 139.5 35.804688 L 137.378906 35.804688 Z M 137.378906 31.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 139.5 40.027344 C 139.292969 40.027344 139.125 39.859375 139.125 39.652344 L 139.125 31.777344 C 139.125 31.570312 139.292969 31.402344 139.5 31.402344 C 139.707031 31.402344 139.875 31.570312 139.875 31.777344 L 139.875 39.652344 C 139.875 39.753906 139.835938 39.847656 139.765625 39.917969 C 139.695312 39.988281 139.597656 40.027344 139.5 40.027344 Z M 139.5 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 142.246094 40.027344 C 142.039062 40.027344 141.871094 39.859375 141.871094 39.652344 L 141.871094 38.527344 C 141.871094 38.320312 142.039062 38.152344 142.246094 38.152344 C 142.34375 38.152344 142.441406 38.191406 142.511719 38.261719 C 142.582031 38.332031 142.621094 38.429688 142.621094 38.527344 L 142.621094 39.652344 C 142.621094 39.753906 142.582031 39.847656 142.511719 39.917969 C 142.441406 39.988281 142.34375 40.027344 142.246094 40.027344 Z M 142.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 148.246094 40.027344 C 148.039062 40.027344 147.871094 39.859375 147.871094 39.652344 L 147.871094 38.527344 C 147.871094 38.320312 148.039062 38.152344 148.246094 38.152344 C 148.34375 38.152344 148.441406 38.191406 148.511719 38.261719 C 148.582031 38.332031 148.621094 38.429688 148.621094 38.527344 L 148.621094 39.652344 C 148.621094 39.753906 148.582031 39.847656 148.511719 39.917969 C 148.441406 39.988281 148.34375 40.027344 148.246094 40.027344 Z M 148.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 103.246094 40.027344 C 103.039062 40.027344 102.871094 39.859375 102.871094 39.652344 L 102.871094 37.027344 C 102.871094 36.820312 103.039062 36.652344 103.246094 36.652344 C 103.34375 36.652344 103.441406 36.691406 103.511719 36.761719 C 103.582031 36.832031 103.621094 36.929688 103.621094 37.027344 L 103.621094 39.652344 C 103.621094 39.753906 103.582031 39.847656 103.511719 39.917969 C 103.441406 39.988281 103.34375 40.027344 103.246094 40.027344 Z M 103.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 109.246094 40.027344 C 109.039062 40.027344 108.871094 39.859375 108.871094 39.652344 L 108.871094 37.027344 C 108.871094 36.820312 109.039062 36.652344 109.246094 36.652344 C 109.34375 36.652344 109.441406 36.691406 109.511719 36.761719 C 109.582031 36.832031 109.621094 36.929688 109.621094 37.027344 L 109.621094 39.652344 C 109.621094 39.753906 109.582031 39.847656 109.511719 39.917969 C 109.441406 39.988281 109.34375 40.027344 109.246094 40.027344 Z M 109.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 100.246094 40.027344 C 100.039062 40.027344 99.871094 39.859375 99.871094 39.652344 L 99.871094 38.527344 C 99.871094 38.320312 100.039062 38.152344 100.246094 38.152344 C 100.34375 38.152344 100.441406 38.191406 100.511719 38.261719 C 100.582031 38.332031 100.621094 38.429688 100.621094 38.527344 L 100.621094 39.652344 C 100.621094 39.753906 100.582031 39.847656 100.511719 39.917969 C 100.441406 39.988281 100.34375 40.027344 100.246094 40.027344 Z M 100.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 106.246094 40.027344 C 106.039062 40.027344 105.871094 39.859375 105.871094 39.652344 L 105.871094 38.527344 C 105.871094 38.320312 106.039062 38.152344 106.246094 38.152344 C 106.34375 38.152344 106.441406 38.191406 106.511719 38.261719 C 106.582031 38.332031 106.621094 38.429688 106.621094 38.527344 L 106.621094 39.652344 C 106.621094 39.753906 106.582031 39.847656 106.511719 39.917969 C 106.441406 39.988281 106.34375 40.027344 106.246094 40.027344 Z M 106.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 115.246094 40.027344 C 115.039062 40.027344 114.871094 39.859375 114.871094 39.652344 L 114.871094 37.027344 C 114.871094 36.820312 115.039062 36.652344 115.246094 36.652344 C 115.34375 36.652344 115.441406 36.691406 115.511719 36.761719 C 115.582031 36.832031 115.621094 36.929688 115.621094 37.027344 L 115.621094 39.652344 C 115.621094 39.753906 115.582031 39.847656 115.511719 39.917969 C 115.441406 39.988281 115.34375 40.027344 115.246094 40.027344 Z M 115.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 121.246094 40.027344 C 121.039062 40.027344 120.871094 39.859375 120.871094 39.652344 L 120.871094 37.027344 C 120.871094 36.820312 121.039062 36.652344 121.246094 36.652344 C 121.34375 36.652344 121.441406 36.691406 121.511719 36.761719 C 121.582031 36.832031 121.621094 36.929688 121.621094 37.027344 L 121.621094 39.652344 C 121.621094 39.753906 121.582031 39.847656 121.511719 39.917969 C 121.441406 39.988281 121.34375 40.027344 121.246094 40.027344 Z M 121.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 112.246094 40.027344 C 112.039062 40.027344 111.871094 39.859375 111.871094 39.652344 L 111.871094 38.527344 C 111.871094 38.320312 112.039062 38.152344 112.246094 38.152344 C 112.34375 38.152344 112.441406 38.191406 112.511719 38.261719 C 112.582031 38.332031 112.621094 38.429688 112.621094 38.527344 L 112.621094 39.652344 C 112.621094 39.753906 112.582031 39.847656 112.511719 39.917969 C 112.441406 39.988281 112.34375 40.027344 112.246094 40.027344 Z M 112.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 118.246094 40.027344 C 118.039062 40.027344 117.871094 39.859375 117.871094 39.652344 L 117.871094 38.527344 C 117.871094 38.320312 118.039062 38.152344 118.246094 38.152344 C 118.34375 38.152344 118.441406 38.191406 118.511719 38.261719 C 118.582031 38.332031 118.621094 38.429688 118.621094 38.527344 L 118.621094 39.652344 C 118.621094 39.753906 118.582031 39.847656 118.511719 39.917969 C 118.441406 39.988281 118.34375 40.027344 118.246094 40.027344 Z M 118.246094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 126.496094 40.027344 C 126.289062 40.027344 126.121094 39.859375 126.121094 39.652344 L 126.121094 37.027344 C 126.121094 36.820312 126.289062 36.652344 126.496094 36.652344 C 126.59375 36.652344 126.691406 36.691406 126.761719 36.761719 C 126.832031 36.832031 126.871094 36.929688 126.871094 37.027344 L 126.871094 39.652344 C 126.871094 39.753906 126.832031 39.847656 126.761719 39.917969 C 126.691406 39.988281 126.59375 40.027344 126.496094 40.027344 Z M 126.496094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 123.496094 40.027344 C 123.289062 40.027344 123.121094 39.859375 123.121094 39.652344 L 123.121094 38.527344 C 123.121094 38.320312 123.289062 38.152344 123.496094 38.152344 C 123.59375 38.152344 123.691406 38.191406 123.761719 38.261719 C 123.832031 38.332031 123.871094 38.429688 123.871094 38.527344 L 123.871094 39.652344 C 123.871094 39.753906 123.832031 39.847656 123.761719 39.917969 C 123.691406 39.988281 123.59375 40.027344 123.496094 40.027344 Z M 123.496094 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 124.371094 46.214844 L 121.746094 46.214844 C 121.539062 46.214844 121.371094 46.046875 121.371094 45.839844 C 121.371094 45.632812 121.539062 45.464844 121.746094 45.464844 L 124.371094 45.464844 C 124.578125 45.464844 124.746094 45.632812 124.746094 45.839844 C 124.746094 46.046875 124.578125 46.214844 124.371094 46.214844 Z M 124.371094 46.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 124.371094 52.214844 L 121.746094 52.214844 C 121.539062 52.214844 121.371094 52.046875 121.371094 51.839844 C 121.371094 51.632812 121.539062 51.464844 121.746094 51.464844 L 124.371094 51.464844 C 124.578125 51.464844 124.746094 51.632812 124.746094 51.839844 C 124.746094 52.046875 124.578125 52.214844 124.371094 52.214844 Z M 124.371094 52.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 122.871094 43.214844 L 121.746094 43.214844 C 121.539062 43.214844 121.371094 43.046875 121.371094 42.839844 C 121.371094 42.632812 121.539062 42.464844 121.746094 42.464844 L 122.871094 42.464844 C 123.078125 42.464844 123.246094 42.632812 123.246094 42.839844 C 123.246094 43.046875 123.078125 43.214844 122.871094 43.214844 Z M 122.871094 43.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 122.871094 49.214844 L 121.746094 49.214844 C 121.539062 49.214844 121.371094 49.046875 121.371094 48.839844 C 121.371094 48.632812 121.539062 48.464844 121.746094 48.464844 L 122.871094 48.464844 C 123.078125 48.464844 123.246094 48.632812 123.246094 48.839844 C 123.246094 49.046875 123.078125 49.214844 122.871094 49.214844 Z M 122.871094 49.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 124.371094 58.214844 L 121.746094 58.214844 C 121.539062 58.214844 121.371094 58.046875 121.371094 57.839844 C 121.371094 57.632812 121.539062 57.464844 121.746094 57.464844 L 124.371094 57.464844 C 124.578125 57.464844 124.746094 57.632812 124.746094 57.839844 C 124.746094 58.046875 124.578125 58.214844 124.371094 58.214844 Z M 124.371094 58.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 122.871094 55.214844 L 121.746094 55.214844 C 121.539062 55.214844 121.371094 55.046875 121.371094 54.839844 C 121.371094 54.632812 121.539062 54.464844 121.746094 54.464844 L 122.871094 54.464844 C 123.078125 54.464844 123.246094 54.632812 123.246094 54.839844 C 123.246094 55.046875 123.078125 55.214844 122.871094 55.214844 Z M 122.871094 55.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(56.470588%,56.470588%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 121.746094 60.773438 L 129.621094 60.773438 L 129.621094 62.894531 L 121.746094 62.894531 Z M 121.746094 60.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 129.621094 61.148438 L 121.746094 61.148438 C 121.542969 61.144531 121.375 60.976562 121.371094 60.773438 C 121.371094 60.566406 121.539062 60.398438 121.746094 60.398438 L 129.621094 60.398438 C 129.722656 60.398438 129.816406 60.4375 129.886719 60.507812 C 129.957031 60.578125 129.996094 60.671875 129.996094 60.773438 C 129.992188 60.976562 129.828125 61.144531 129.621094 61.148438 Z M 129.621094 61.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 112.363281 26.65625 C 112.097656 26.65625 111.851562 26.511719 111.71875 26.28125 C 111.585938 26.054688 111.582031 25.769531 111.710938 25.539062 C 111.90625 25.1875 116.632812 16.890625 123.996094 16.890625 C 124.410156 16.890625 124.746094 17.226562 124.746094 17.640625 C 124.746094 18.054688 124.410156 18.390625 123.996094 18.390625 C 117.515625 18.390625 113.0625 26.191406 113.023438 26.273438 C 112.890625 26.511719 112.636719 26.65625 112.363281 26.65625 Z M 112.363281 26.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,60.784314%,69.019608%)",
      fillOpacity: 1
    },
    d: "M 161.054688 72.75 L 90.203125 72.75 L 90.203125 66.046875 C 113.792969 67.539062 137.457031 67.539062 161.046875 66.046875 Z M 161.054688 72.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 161.054688 73.5 L 90.203125 73.5 C 89.789062 73.5 89.453125 73.164062 89.453125 72.75 L 89.453125 66.046875 C 89.453125 65.839844 89.539062 65.640625 89.6875 65.5 C 89.839844 65.355469 90.039062 65.28125 90.246094 65.296875 C 113.808594 66.785156 137.441406 66.785156 161.003906 65.296875 C 161.210938 65.28125 161.414062 65.355469 161.566406 65.496094 C 161.71875 65.640625 161.804688 65.835938 161.804688 66.046875 L 161.804688 72.75 C 161.804688 72.949219 161.726562 73.140625 161.585938 73.28125 C 161.445312 73.421875 161.253906 73.5 161.054688 73.5 Z M 90.953125 72 L 160.304688 72 L 160.304688 66.839844 C 137.210938 68.265625 114.046875 68.265625 90.953125 66.839844 Z M 90.953125 72 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllWaistline);
export default __webpack_public_path__ + "static/media/ill_waistline.d8a8a46fc1ef71ba0e92f52356665019.svg";
export { ForwardRef as ReactComponent };